/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open the cart drawer ONLY when the shopper deliberately asked for
 *   it (basket icon, Checkout FAB, "view cart" style links).
 *
 * Royal Mist: adding to cart must NOT slide the side drawer in and squeeze the
 * page — the black cart notification is the only confirmation. Add-to-cart
 * flows call Shopify.actions.openCart() programmatically, so we gate that call
 * behind a recent trusted click, and additionally close any drawer that manages
 * to open without one.
 */

var RM_TRUST_WINDOW = 1500;
var rmTrustedUntil = 0;

var RM_TRUSTED_OPENERS = [
  '#rm-checkout-fab',
  '#cart-drawer',
  '[on\\:click*="cart-drawer/open"]',
  '[data-rm-open-cart]',
  '.header-actions__cart-icon',
  '.header__cart',
];

function rmIsTrustedTarget(el) {
  if (!el || !el.closest) return false;
  for (var i = 0; i < RM_TRUSTED_OPENERS.length; i++) {
    try {
      if (el.closest(RM_TRUSTED_OPENERS[i])) return true;
    } catch (e) {}
  }
  return false;
}

document.addEventListener(
  'click',
  function (event) {
    if (rmIsTrustedTarget(event.target)) {
      rmTrustedUntil = Date.now() + RM_TRUST_WINDOW;
    }
  },
  true
);

function rmTrusted() {
  return Date.now() < rmTrustedUntil;
}

/** Belt and braces: close the drawer if it opens without a trusted click. */
function rmGuardDrawer() {
  var drawer = document.querySelector('theme-drawer#cart-drawer');
  if (!drawer || drawer.dataset.rmGuarded === '1') return;
  drawer.dataset.rmGuarded = '1';

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName !== 'open') continue;
      if (!drawer.hasAttribute('open')) continue;
      if (rmTrusted()) continue;
      try {
        if (typeof drawer.close === 'function') drawer.close();
        else drawer.removeAttribute('open');
      } catch (e) {}
    }
  }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
}

function init() {
  rmGuardDrawer();

  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      // Programmatic open straight after an add-to-cart: ignore it. The black
      // cart notification already confirms the add and offers View cart.
      if (!rmTrusted()) return;

      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

// The drawer markup can be re-rendered by the Section Rendering API, so re-arm
// the guard once the DOM has settled.
document.addEventListener('DOMContentLoaded', rmGuardDrawer, { once: true });
